import { FEL_CERTIFIER, FEL_IVA_AFFILIATION, FEL_PHRASE_TYPE_ISR, FEL_PHRASE_TYPE_SMALL_TAXPAYER, } from './catalog.js';
/** Código del establecimiento de la casa matriz en el RTU. */
export const DEFAULT_FEL_ESTABLISHMENT_CODE = 1;
/** Escenario 1 de la frase del ISR: "Sujeto a pagos trimestrales ISR", el régimen más común. */
const DEFAULT_ISR_SCENARIO = 1;
/** Escenario 1 de pequeño contribuyente: "No genera derecho a crédito fiscal". */
const SMALL_TAXPAYER_SCENARIO = 1;
/**
 * Escenario de exención por omisión: el que cita el art. 7 num. 4 de la Ley
 * del IVA (catálogo de frases tipo 4). SUPUESTO a confirmar con el asesor
 * fiscal: cada entidad elige el suyo en la configuración.
 */
export const DEFAULT_FEL_EXEMPTION_SCENARIO = 2;
/** Dirección por omisión del emisor (zona 1 de la Ciudad de Guatemala). */
const DEFAULT_FEL_ADDRESS = { postalCode: '01001', municipality: 'Guatemala', department: 'Guatemala' };
/**
 * Afiliación al IVA sugerida por tipo de organización. Las cooperativas
 * suelen estar inscritas en el régimen general aunque sus servicios a
 * asociados estén exentos: la exención se expresa línea por línea con la
 * frase tipo 4 (y con `taxOnInterest` en 0).
 */
export const DEFAULT_FEL_AFFILIATION = {
    microfinance_entity: FEL_IVA_AFFILIATION.GEN,
    microfinance_ngo: FEL_IVA_AFFILIATION.GEN,
    cooperative: FEL_IVA_AFFILIATION.GEN,
    finance_company: FEL_IVA_AFFILIATION.GEN,
    private_lender: FEL_IVA_AFFILIATION.GEN,
};
/** Frases generales por omisión de una afiliación al IVA. */
export function defaultFelPhrases(affiliation) {
    if (affiliation === FEL_IVA_AFFILIATION.PEQ)
        return [{ type: FEL_PHRASE_TYPE_SMALL_TAXPAYER, scenario: SMALL_TAXPAYER_SCENARIO }];
    return [{ type: FEL_PHRASE_TYPE_ISR, scenario: DEFAULT_ISR_SCENARIO }];
}
/**
 * Configuración FEL inicial de un tipo de organización. Nace APAGADA: emitir
 * facturas exige inscripción en FEL ante la SAT y contrato con un
 * certificador, así que la institución la activa conscientemente.
 */
export function defaultFelSettings(type, commercialName) {
    const ivaAffiliation = DEFAULT_FEL_AFFILIATION[type];
    return {
        enabled: false,
        certifier: FEL_CERTIFIER.sandbox,
        commercialName,
        establishmentCode: DEFAULT_FEL_ESTABLISHMENT_CODE,
        ivaAffiliation,
        phrases: defaultFelPhrases(ivaAffiliation),
        exemptionScenario: DEFAULT_FEL_EXEMPTION_SCENARIO,
        emailCopy: false,
        address: { ...DEFAULT_FEL_ADDRESS },
    };
}
/**
 * Configuración FEL guardada combinada sobre los valores por defecto, para
 * que una instalación anterior a la facturación electrónica tenga un valor
 * completo antes de que el administrador la guarde.
 */
export function withFelDefaults(saved, type, commercialName) {
    const defaults = defaultFelSettings(type, commercialName);
    return { ...defaults, ...saved, address: { ...defaults.address, ...saved?.address } };
}
//# sourceMappingURL=settings.js.map